import { Row, Col } from "antd";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import TopEntityCarouselCard from "./statistics.top.card";
import StatisticCountCard from "./statistics.count.card";

const CardSummaryPanel = ({
  filters = {},
  designationData = [],
  conditionsData = [],
  usersCount = {},
  guidelinesCount = {},
}) => {
  const { activeUsers, change: userChangeOffset } = usersCount;
  const { guidelineViews, change: guidelineChangeOffset } = guidelinesCount;

  const userChangeUp = userChangeOffset > 0;
  const userChangeNeutral = userChangeOffset == 0;
  const viewsChangeUp = guidelineChangeOffset > 0;
  const viewsChangeNeutral = guidelineChangeOffset == 0;

  const { designationRankingLimit, conditionRankingLimit } = filters;

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={4}>
        <StatisticCountCard
          title="Active Users"
          value={activeUsers}
          prefix={
            userChangeUp ? (
              <CaretUpOutlined style={{ color: "#3f8600" }} />
            ) : userChangeNeutral ? null : (
              <CaretDownOutlined style={{ color: "#cf1322" }} />
            )
          }
          suffix={"users"}
        />
      </Col>
      <Col xs={24} sm={12} md={4}>
        <StatisticCountCard
          title="Guideline Views"
          value={guidelineViews}
          prefix={
            viewsChangeUp ? (
              <CaretUpOutlined style={{ color: "#3f8600" }} />
            ) : viewsChangeNeutral ? null : (
              <CaretDownOutlined style={{ color: "#cf1322" }} />
            )
          }
          suffix={"views"}
        />
      </Col>
      <Col xs={24} sm={12} md={8}>
        <TopEntityCarouselCard
          title="Most Active User Designations"
          data={designationData.slice(0, designationRankingLimit)}
          extra={`Top ${designationRankingLimit}`}
        />
      </Col>
      <Col xs={24} sm={12} md={8}>
        <TopEntityCarouselCard
          title="Most Viewed Guidelines"
          extra={`Top ${conditionRankingLimit}`}
          data={conditionsData.slice(0, conditionRankingLimit)}
        />
      </Col>
    </Row>
  );
};

export default CardSummaryPanel;
